import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatCommonModule} from '@angular/material/core';
import {MatCardModule} from "@angular/material/card";
import {EvkFirmaDigitalComponent} from "./componentes/firma-digital/evk-firma-digital/evk-firma-digital.component";
import {
    EvkFirmaElectronicaComponent
} from "./componentes/firma-electronica/evk-firma-electronica/evk-firma-electronica.component";
import {
    EvkFirmaDigitalDialogComponent
} from "./componentes/firma-digital/evk-firma-digital-dialog/evk-firma-digital-dialog.component";
import {
    EvkFirmaElectronicaDialogComponent
} from "./componentes/firma-electronica/evk-firma-electronica-dialog/evk-firma-electronica-dialog.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {ReactiveFormsModule} from "@angular/forms";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDividerModule} from "@angular/material/divider";
import {MatTableModule} from "@angular/material/table";
import {MatMenuModule} from "@angular/material/menu";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatInputModule} from "@angular/material/input";
import {SignaturePadModule} from 'angular2-signaturepad';
//import {NgxMatFileInputModule} from "@angular-material-components/file-input";
import {OcspConfig} from "./componentes/config/ocsp-config";
import { MaterialFileInputModule } from 'ngx-material-file-input';

@NgModule({
    declarations: [
        EvkFirmaDigitalComponent,
        EvkFirmaElectronicaComponent,
        EvkFirmaDigitalDialogComponent,
        EvkFirmaElectronicaDialogComponent
    ],
    imports: [
        MatCardModule,
        CommonModule,
        MatCommonModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatDividerModule,
        MatTableModule,
        MatMenuModule,
        MatDialogModule,
        MatToolbarModule,
        SignaturePadModule,
        //NgxMatFileInputModule,
        MaterialFileInputModule
    ],
    exports: [
        EvkFirmaDigitalComponent,
        EvkFirmaElectronicaComponent,
        EvkFirmaElectronicaDialogComponent
    ],
    entryComponents: [
        EvkFirmaDigitalDialogComponent,
        EvkFirmaElectronicaDialogComponent
    ]
})
export class FirmaModule {

    static forRoot( ocspConfig?: OcspConfig): ModuleWithProviders<FirmaModule> {
        return {
            ngModule: FirmaModule,
            providers: [

                {
                    provide: 'ocspConfig', useValue: ocspConfig
                }
            ]
        };
    }
}
